// extracted by mini-css-extract-plugin
module.exports = {"swoosh":"theme-2025_swoosh__JN0Fw","swooshContainer":"theme-2025_swooshContainer__kAHqs","swooshLayer":"theme-2025_swooshLayer__gSwOO","strapline":"theme-2025_strapline__aos2a"};